import type { Skin } from '@/libs/campaigns/types';
import { imageIllustration } from '@/libs/campaigns/illustrations';
import emptyState from '@/public/assets/campaigns/christmas-2025/empty-state.webp';
import freeGoldCoinChest from '@/public/assets/campaigns/christmas-2025/free-gold-coin-chest.webp';
import infoBannerDesktop from '@/public/assets/campaigns/christmas-2025/info-banner-desktop.webp';
import infoBannerMobile from '@/public/assets/campaigns/christmas-2025/info-banner-mobile.webp';
import notFoundGarland from '@/public/assets/campaigns/christmas-2025/not-found-garland.webp';

/** Christmas as the former build-time variant shipped it: art only, the default logo stays. */
export const christmas2025Skin: Skin = {
  illustrations: {
    lobbyInfoBannerDesktop: imageIllustration(infoBannerDesktop),
    lobbyInfoBannerMobile: imageIllustration(infoBannerMobile),
    freeGoldCoinChest: imageIllustration(freeGoldCoinChest),
    emptyState: imageIllustration(emptyState),
    emptyStateCompact: imageIllustration(emptyState),
    emptyFavorites: imageIllustration(emptyState),
    notFoundGarland: imageIllustration(notFoundGarland),
  },
  messages: {
    en: {
      logoAlt: 'SweepKing Christmas',
    },
  },
};
